export default __webpack_public_path__ + "static/media/logo.bb84f5a6.png";